import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {DashboardContent} from 'components/DashboardContent/styles';
import Loading from 'components/shared/Utils/Loading';
import EmptyState from 'routes/App/inviteABite/EmptyState';
import ActiveState from 'routes/App/inviteABite/ActiveState';
import {
  CLEAR_INVITE_A_BITE_DATA,
  GET_INVITE_A_BITE_INFO
} from 'store/inviteABite/action';

const InviteABite = () => {
  const dispatch = useDispatch();
  const locationId = useSelector((state) => state.user?.activeLocation?._id);
  const data = useSelector((state) => state.inviteABiteReducer.data);
  const loading = useSelector((state) => state.inviteABiteReducer.loading);

  useEffect(() => {
    if (locationId) {
      dispatch(GET_INVITE_A_BITE_INFO());
    }
    return () => {
      dispatch(CLEAR_INVITE_A_BITE_DATA());
    };
  }, [locationId]);

  const showLoading = loading && !data;

  return (
    <DashboardContent className='DashboardContent'>
      {showLoading && <Loading margin='80px 0' />}
      {!showLoading && data?.isEnabled && <ActiveState data={data} />}
      {!showLoading && !data?.isEnabled && <EmptyState />}
    </DashboardContent>
  );
};

export default InviteABite;
